module.exports = __webpack_public_path__ + "img/studio__home__mobile.7a5a184b.svg";